export enum Sources {
    DEFAULT = "",
    WAPO = "washingtonpost.com",
    FOX = "foxnews.com",
    CNN = "cnn.com",
    NBC = "nbcnews.com",
    AP = "apnews.com"
}
